import { render, staticRenderFns } from "./typeCard.vue?vue&type=template&id=3c52ef0b"
import script from "./typeCard.vue?vue&type=script&lang=js"
export * from "./typeCard.vue?vue&type=script&lang=js"
import style0 from "./typeCard.vue?vue&type=style&index=0&id=3c52ef0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports